"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerApi = exports.CountyCode = void 0;
const axios_1 = require("axios");
const globalImportUrl = require("url");
const base_1 = require("../base");
var CountyCode;
(function (CountyCode) {
    CountyCode["_1"] = "1";
    CountyCode["_2"] = "2";
    CountyCode["_3"] = "3";
    CountyCode["_4"] = "4";
    CountyCode["_5"] = "5";
    CountyCode["_6"] = "6";
    CountyCode["_7"] = "7";
    CountyCode["_8"] = "8";
    CountyCode["_9"] = "9";
    CountyCode["_10"] = "10";
    CountyCode["_11"] = "11";
    CountyCode["_12"] = "12";
    CountyCode["_13"] = "13";
    CountyCode["_14"] = "14";
    CountyCode["_15"] = "15";
    CountyCode["_16"] = "16";
    CountyCode["_17"] = "17";
    CountyCode["_18"] = "18";
    CountyCode["_19"] = "19";
    CountyCode["_2A"] = "2A";
    CountyCode["_2B"] = "2B";
    CountyCode["_21"] = "21";
    CountyCode["_22"] = "22";
    CountyCode["_23"] = "23";
    CountyCode["_24"] = "24";
    CountyCode["_25"] = "25";
    CountyCode["_26"] = "26";
    CountyCode["_27"] = "27";
    CountyCode["_28"] = "28";
    CountyCode["_29"] = "29";
    CountyCode["_30"] = "30";
    CountyCode["_31"] = "31";
    CountyCode["_32"] = "32";
    CountyCode["_33"] = "33";
    CountyCode["_34"] = "34";
    CountyCode["_35"] = "35";
    CountyCode["_36"] = "36";
    CountyCode["_37"] = "37";
    CountyCode["_38"] = "38";
    CountyCode["_39"] = "39";
    CountyCode["_40"] = "40";
    CountyCode["_41"] = "41";
    CountyCode["_42"] = "42";
    CountyCode["_43"] = "43";
    CountyCode["_44"] = "44";
    CountyCode["_45"] = "45";
    CountyCode["_46"] = "46";
    CountyCode["_47"] = "47";
    CountyCode["_48"] = "48";
    CountyCode["_49"] = "49";
    CountyCode["_50"] = "50";
    CountyCode["_51"] = "51";
    CountyCode["_52"] = "52";
    CountyCode["_53"] = "53";
    CountyCode["_54"] = "54";
    CountyCode["_55"] = "55";
    CountyCode["_56"] = "56";
    CountyCode["_57"] = "57";
    CountyCode["_58"] = "58";
    CountyCode["_59"] = "59";
    CountyCode["_60"] = "60";
    CountyCode["_61"] = "61";
    CountyCode["_62"] = "62";
    CountyCode["_63"] = "63";
    CountyCode["_64"] = "64";
    CountyCode["_65"] = "65";
    CountyCode["_66"] = "66";
    CountyCode["_67"] = "67";
    CountyCode["_68"] = "68";
    CountyCode["_69"] = "69";
    CountyCode["_70"] = "70";
    CountyCode["_71"] = "71";
    CountyCode["_72"] = "72";
    CountyCode["_73"] = "73";
    CountyCode["_74"] = "74";
    CountyCode["_75"] = "75";
    CountyCode["_76"] = "76";
    CountyCode["_77"] = "77";
    CountyCode["_78"] = "78";
    CountyCode["_79"] = "79";
    CountyCode["_80"] = "80";
    CountyCode["_81"] = "81";
    CountyCode["_82"] = "82";
    CountyCode["_83"] = "83";
    CountyCode["_84"] = "84";
    CountyCode["_85"] = "85";
    CountyCode["_86"] = "86";
    CountyCode["_87"] = "87";
    CountyCode["_88"] = "88";
    CountyCode["_89"] = "89";
    CountyCode["_90"] = "90";
    CountyCode["_91"] = "91";
    CountyCode["_92"] = "92";
    CountyCode["_93"] = "93";
    CountyCode["_94"] = "94";
    CountyCode["_95"] = "95";
})(CountyCode = exports.CountyCode || (exports.CountyCode = {}));
function PartnerApiAxiosParamCreator(configuration) {
    return {
        getPartnerPage(slug, options = {}) {
            if (slug === null || slug === undefined) {
                throw new base_1.RequiredError("slug", "Required parameter slug was null or undefined when calling getPartnerPage.");
            }
            const localVarPath = `/partners/{slug}`.replace(`{slug}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPartners(countyCodes, partnerNameQuery, options = {}) {
            const localVarPath = `/partners`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (countyCodes) {
                localVarQueryParameter["countyCodes[]"] = countyCodes;
            }
            if (partnerNameQuery !== undefined) {
                localVarQueryParameter["partnerNameQuery"] = partnerNameQuery;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function PartnerApiFp(configuration) {
    return {
        getPartnerPage(slug, options) {
            const localVarAxiosArgs = PartnerApiAxiosParamCreator(configuration).getPartnerPage(slug, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getPartners(countyCodes, partnerNameQuery, options) {
            const localVarAxiosArgs = PartnerApiAxiosParamCreator(configuration).getPartners(countyCodes, partnerNameQuery, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class PartnerApi extends base_1.BaseAPI {
    getPartnerPage(slug, options) {
        return PartnerApiFp(this.configuration).getPartnerPage(slug, options)(this.axios, this.basePath);
    }
    getPartners(countyCodes, partnerNameQuery, options) {
        return PartnerApiFp(this.configuration).getPartners(countyCodes, partnerNameQuery, options)(this.axios, this.basePath);
    }
}
exports.PartnerApi = PartnerApi;
